"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AspectRatioBox = void 0;
var react_1 = __importDefault(require("react"));
var proportional_scale_1 = require("proportional-scale");
var Box_1 = require("../Box");
var responsiveScale = function (args) {
    if ("maxWidth" in args && args.maxWidth === "100%") {
        return {
            maxWidth: "100%",
            paddingBottom: (0, proportional_scale_1.paddingBottom)({
                width: args.aspectWidth,
                height: args.aspectHeight,
            }),
        };
    }
    var width = args.aspectWidth, height = args.aspectHeight, rest = __rest(args, ["aspectWidth", "aspectHeight"]);
    // @ts-ignore
    var scaled = (0, proportional_scale_1.scale)(__assign({ width: width, height: height }, rest));
    return {
        maxWidth: "".concat(scaled.width, "px"),
        paddingBottom: scaled.paddingBottom,
    };
};
var AspectRatioBox = function (_a) {
    var aspectWidth = _a.aspectWidth, aspectHeight = _a.aspectHeight, children = _a.children, rest = __rest(_a, ["aspectWidth", "aspectHeight", "children"]);
    var scaled = responsiveScale(__assign({ aspectHeight: aspectHeight, aspectWidth: aspectWidth }, rest));
    return (react_1.default.createElement(Box_1.Box, __assign({ position: "relative", width: "100%", style: { maxWidth: scaled.maxWidth } }, rest),
        react_1.default.createElement(Box_1.Box, { position: "relative", width: "100%", height: 0, overflow: "hidden", paddingBottom: scaled.paddingBottom }),
        react_1.default.createElement(Box_1.Box, { position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }, children)));
};
exports.AspectRatioBox = AspectRatioBox;
exports.AspectRatioBox.displayName = "AspectRatioBox";
//# sourceMappingURL=AspectRatioBox.js.map